import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonService } from '../service/common.service';
import { ProjectSeoService } from 'src/app/services/projectseo.service';
import { environment } from 'src/environments/environment';
import { ApicallService } from 'src/app/services/apicall.service';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
@Component({
  selector: 'app-kes',
  templateUrl: './kes.component.html',
  styleUrls: ['./kes.component.css']
})
export class KesComponent {
  admissionForm: FormGroup;
  submitted = false;
  randomOtp: any;
  otpInput: boolean = false
  otp_msg: any;
  otp_ValidMsg: boolean = false
  otp_inValidMsg: boolean = false
  countryList: any;
  stateList: any;
  cityList: any;
  selectedDevice: string = "";
  franchiseeList: any;
  studentID: any;
  program_id: any;
  gen_captcha: any;
  filterFranchisee: any;
  locationName: any;
  selectedcountry: string = "";
  selectedstate: string = "";
  selectedCity: string = "";
  selectedpincode: string = "";
  franchiseeMobileNo: string = "";
  form_title: boolean = true;
  generatedcaptcha: string = "";
  captchaText: any = []
  captchaEntered: String = ""
  utm_source:string="Website";
  utm_medium:string="Website";
  utm_compaign:string="Website";
  gclid:string="Website";
  utm_term:string="Website";
  utm_content:string="Website";
  utm_ad:string="Website";
  constructor(private fb: FormBuilder, private ngxSpinner: NgxSpinnerService, private _servie: CommonService, private _activeRoute: ActivatedRoute, private router: Router,
    private projectService: ProjectSeoService,
    private apiService: ApicallService) {
      this.admissionForm = fb.group({
        fname: ['', Validators.required],
        lname: ['', Validators.required],
        email: ['', [Validators.required, Validators.email]],
        mobile: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
        pinCode: ['', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{6}$")]],
        country: ['', Validators.required],
        state: ['', Validators.required],
        city: ['', Validators.required],
        otp: ['', Validators.required],
        location: ['', Validators.required]
      })
  }

  ngOnInit(): void {
    this.getseo();
      this._activeRoute.queryParams.subscribe((params: Params) => {
        this.utm_source=params["utm_source"]!=null?params["utm_source"]:this.utm_source;
        this.utm_medium=params["utm_medium"]!=null?params["utm_medium"]:this.utm_medium;
        this.utm_compaign=params["utm_campaign"]!=null?params["utm_campaign"]:this.utm_compaign;
        this.gclid=params["gclid"]!=null?params["gclid"]:this.gclid;
        this.utm_term=params["utm_term"]!=null?params["utm_term"]:this.utm_term;
        this.utm_content=params["utm_content"]!=null?params["utm_content"]:this.utm_source;
        this.utm_ad=params["utm_ad"]!=null?params["utm_ad"]:this.utm_ad;
      });
    }

    getseo() {
      let tbody = {
        slug: 'elementary-school',
        Projectid: environment.projectid,
      };
      this.apiService.getGetseo(tbody).subscribe((data: any) => {
       this.projectService.sendMessagebread(data?.data?.breadcrumb);
       this.projectService.sendMessageblog(data?.data?.blog);
       this.projectService.sendMessageseo(data?.data?.testimony);
       this.projectService.sendMessageFaqs(data?.data?.faq);
       this.projectService.setmeta(data.data);
      });
      this.scrollToPosition();
    }

    scrollToPosition() {
      window.scrollTo({
        top: 300,  // Scroll to the top of the page
        left: 0, // Horizontal scroll (set to 0 for no horizontal scroll)
        behavior: 'smooth'  // Smooth scrolling effect
      });
    }

}
